<template>
    <div>
        <v-row>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(1)">1</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(2)">2</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(3)">3</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(4)">4</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(5)">5</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(6)">6</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(7)">7</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(8)">8</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(9)">9</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr('+')">+</v-btn>
            </v-col>
            <v-col align="center">
                <v-btn rounded outlined @click="addNr(0)">0</v-btn>
            </v-col>
            <v-col align="center"></v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    methods: {
        addNr(number) {
            let newValue = this.value;
            if (newValue === null) {
                newValue = '';
            }

            this.$emit('input', newValue + number);
        },
    }
}
</script>
